import { forwardRef } from "react";
import classNames from "classnames";
import { Division } from "@ir/ui";

interface PageContentProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const PageContent = forwardRef<HTMLDivElement, PageContentProps>(
  ({ children, className, style }, ref) => {
    const mainContentClass = classNames("main-content-aria", className);
    return (
      <Division className={mainContentClass} style={style} ref={ref}>
        {children}
      </Division>
    );
  }
);

export default PageContent;
